export const translateClasses = {
  top_left: "-translate-x-10 -translate-y-10", // Translate -20px (5 * 4px) for top-left
  top_right: "translate-x-10 -translate-y-10", // Translate +20px for x and -20px for y
  bottom_left: "-translate-x-10 translate-y-10", // Translate -20px for x and +20px for y
  bottom_right: "translate-x-10 translate-y-10", // Translate +20px for bottom-right
  animate: {
    top_left: {
      "--tw-translate-x": "-2.5rem",
      "--tw-translate-y": "-2.5rem",
    },
    top_right: {
      "--tw-translate-x": "2.5rem",
      "--tw-translate-y": "-2.5rem",
    },
    bottom_left: {
      "--tw-translate-x": "-2.5rem",
      "--tw-translate-y": "2.5rem",
    },
    bottom_right: {
      "--tw-translate-x": "2.5rem",
      "--tw-translate-y": "2.5rem",
    },
  },
};
